/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Passingscorepercent_Placeholder2Inputs */

const en__field_passingscorepercent_placeholder2 = /** @type {(inputs: _Field_Passingscorepercent_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passing score percentage`)
};

/**
* | output |
* | --- |
* | "Passing score percentage" |
*
* @param {_Field_Passingscorepercent_Placeholder2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_passingscorepercent_placeholder2 = /** @type {((inputs?: _Field_Passingscorepercent_Placeholder2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Passingscorepercent_Placeholder2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_passingscorepercent_placeholder2(inputs)
});
export { _field_passingscorepercent_placeholder2 as "_field_passingScorePercent_placeholder" }